<template>
  <!-- <div class="footer" v-html="webInfoObj.strFootMessage">

  </div> -->
  <div class="footer">
    <div class="border-10"> </div>

    <div class="inder ">
      <div class="foot-left">
        <img src="../../assets/images/logo.png" alt="">
      </div>
      <div class="foot-right">
        <div style="width:96%;text-align:center;margin-top:10px">
          <p>地址：合肥市包河区中山路1号省行政中心3号楼 邮编：230091</p>
          <p>Copyright &nbsp;&nbsp;{{year}}&nbsp;政协安徽省委员会版权所有 皖ICP备05003837号-1皖公网安备34011102000447号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Links from './links.vue'
export default {
  name: "Footer",
  data () {
    return {
      year: new Date().getFullYear(),
      path: location.href,
      // borderShow: localStorage.getItem('borderShow'),
      // meta: this.$route.meta
    };
  },
  props: {
    webInfoObj: {
      type: Object,
      default: () => [],
    },
  },

  created () {

  },
  mounted () {
  },
  activated () {

  },
  methods: {
  },

};
</script>
<style scoped lang="scss">
.footer {
  box-sizing: border-box;
  padding: 10px 0;
  text-align: center;
  .border-10 {
    display: none;
    border-bottom: 10px solid #4051a1;
    margin: 60px 0 30px;
  }
  .inder {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .foot-left {
      width: 25%;
      text-align: right;
      padding-right: 60px;
    }
    .foot-right {
      text-align: left;
      width: 57%;
    }
  }
}
</style>